// src/index.js

import React from "react";
import ReactDOM from 'react-dom/client';
import * as serviceWorker from "./serviceWorker";
import "./i18n";
import { Provider } from "react-redux";
import store from "./store";

import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from 'react-router-dom';

import App from "./App";
import { authProtectedRoutes, publicRoutes } from "./routes";

const convertRoutesToBrowserRouterFormat = (routes, LayoutComponent = null) => {
  return routes.map(route => {
    if (route.component && route.component.type && route.component.type.name === 'Navigate') {
      return {
        path: route.path,
        element: route.component,
      };
    }

    const routeConfig = {
      path: route.path,
      element: LayoutComponent ? (
        <LayoutComponent>{route.component}</LayoutComponent>
      ) : (
        route.component
      ),
    };

    if (route.index) {
      routeConfig.index = route.index;
    }

    return routeConfig;
  });
};


const mainLayoutRoute = {
  path: "/",
  element: <App />,
  children: authProtectedRoutes.map(route => ({
    path: route.path === '/' ? undefined : route.path.startsWith('/') ? route.path.substring(1) : route.path,
    index: route.path === '/',
    element: route.component,
  })),
};

const allRoutes = [
  ...publicRoutes.map(route => ({
    path: route.path,
    element: route.component,
  })),
  mainLayoutRoute,
  {
    path: "*",
    element: <Navigate to="/pages-404" replace />,
  },
];


const router = createBrowserRouter(allRoutes);


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
      {/* Hapus atau komentari <React.StrictMode> di sini */}
      {/* <React.StrictMode> */}
        <RouterProvider router={router} />
      {/* </React.StrictMode> */}
    </Provider>
);

serviceWorker.unregister();